import MundActiveCampaign from "../icons/MundActiveCampaign";
import Active from "../icons/Active";
import IntegrationTable from "@/components/shared/IntegrationTable/IntegrationTable";
import { integrationFieldPresets } from "@/components/shared/IntegrationTable/integrationFieldPresets";
import { IntegrationEvent, paymentStatus } from "@/utils/paymentMethods";
import { t } from "i18next";

export default function ActiveCampaign() {
  return (
    <IntegrationTable
      integrationKey='active_campaign'
      title='ActiveCampaign'
      main_icon={<MundActiveCampaign />}
      icon={<Active />}
      fields={[
        integrationFieldPresets.access_token,
        integrationFieldPresets.postback_url,
        integrationFieldPresets.metadata,
      ]}
      fixedOptions={{
        active_statuses: [
          ...paymentStatus,
          IntegrationEvent.INITIATE_CHECKOUT,
          IntegrationEvent.CHARGEBACK,
        ],
      }}
      fieldLabels={{
        access_token: "API Token",
        placeholder_access_token: t("sales:access_token"),
        payment_status: t("common:event_type"),
      }}
    />
  );
}
